// extracted by mini-css-extract-plugin
export var active = "scrollSocialProof-module--active--925f8";
export var arrowButton = "scrollSocialProof-module--arrowButton--5ae82";
export var attribution = "scrollSocialProof-module--attribution--a39a9";
export var buttonContainer = "scrollSocialProof-module--buttonContainer--fdd3f";
export var card = "scrollSocialProof-module--card--15a6f";
export var cardContainer = "scrollSocialProof-module--cardContainer--430a3";
export var credit = "scrollSocialProof-module--credit--496f0";
export var customGrid = "scrollSocialProof-module--customGrid--c2cd2";
export var desktopInLeft = "scrollSocialProof-module--desktopInLeft--65974";
export var desktopInRight = "scrollSocialProof-module--desktopInRight--129f0";
export var desktopOutLeft = "scrollSocialProof-module--desktopOutLeft--c2b58";
export var desktopOutRight = "scrollSocialProof-module--desktopOutRight--0f9c2";
export var displayCard = "scrollSocialProof-module--displayCard--b32dd";
export var headline = "scrollSocialProof-module--headline--e161b";
export var headlineContainer = "scrollSocialProof-module--headlineContainer--bf91a";
export var hideCard = "scrollSocialProof-module--hideCard--cdaf7";
export var imgContainer = "scrollSocialProof-module--imgContainer--00aea";
export var mobileInLeft = "scrollSocialProof-module--mobileInLeft--98e8c";
export var mobileInLeftTitle = "scrollSocialProof-module--mobileInLeftTitle--63ddf";
export var mobileInRight = "scrollSocialProof-module--mobileInRight--feeff";
export var mobileInRightTitle = "scrollSocialProof-module--mobileInRightTitle--b0e36";
export var mobileOutLeft = "scrollSocialProof-module--mobileOutLeft--5a388";
export var mobileOutLeftTitle = "scrollSocialProof-module--mobileOutLeftTitle--e7166";
export var mobileOutRight = "scrollSocialProof-module--mobileOutRight--8d4b6";
export var mobileOutRightTitle = "scrollSocialProof-module--mobileOutRightTitle--63b4b";
export var navigationButtonContainer = "scrollSocialProof-module--navigationButtonContainer--c4be7";
export var quote = "scrollSocialProof-module--quote--d802e";
export var scrollSocialProof = "scrollSocialProof-module--scrollSocialProof--7169e";